var _linearGradient, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSteam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233 233"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "steam_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 279.807,
    y1: 116.5,
    x2: 280.307,
    y2: 116.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#136497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#144b7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a1b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1387b8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.1,233H46.9C21,233,0,212,0,186.1V46.9C0,21,21,0,46.9,0h139.2C212,0,233,21,233,46.9v139.2 C233,212,212,233,186.1,233z",
    fill: "url(#steam_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5,87.3c0,0.2,0,0.4,0,0.6L82,129.3c-4.6-0.2-9.3,0.6-13.6,2.4c-1.9,0.8-3.8,1.8-5.5,2.9L0.3,108.8 c0,0-1.4,23.8,4.6,41.6l44.3,18.3c2.2,9.9,9,18.6,19.1,22.8c16.4,6.9,35.4-1,42.2-17.4c1.8-4.3,2.6-8.8,2.5-13.3l40.8-29.1 c0.3,0,0.7,0,1,0c24.4,0,44.2-19.9,44.2-44.3c0-24.4-19.8-44.3-44.2-44.3C130.4,43,110.5,62.9,110.5,87.3z M103.7,171.2 c-5.3,12.7-19.9,18.7-32.6,13.4c-5.9-2.4-10.3-6.9-12.8-12.2l14.4,6c9.4,3.9,20.1-0.5,24-9.9c3.9-9.4-0.5-20.1-9.9-24l-14.9-6.2 c5.7-2.2,12.3-2.3,18.4,0.3c6.2,2.6,10.9,7.4,13.5,13.5S106.2,165.1,103.7,171.2 M154.8,116.9c-16.2,0-29.5-13.2-29.5-29.5 c0-16.3,13.2-29.5,29.5-29.5c16.3,0,29.5,13.3,29.5,29.5C184.2,103.6,171,116.9,154.8,116.9 M132.7,87.3c0-12.3,9.9-22.2,22.1-22.2 c12.2,0,22.1,9.9,22.1,22.2c0,12.3-9.9,22.2-22.1,22.2C142.6,109.5,132.7,99.5,132.7,87.3z",
    fill: "#fff"
  })));
}

export default SvgSteam;